import { StatCard } from "@/components/admin/payouts/primitives";
import type { TherapiesAdminSummary } from "@/types";

function fmtStatMoney(n: number): string {
  return n.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function TherapiesStats({
  total,
  summary,
}: {
  total: number | undefined;
  summary: TherapiesAdminSummary | undefined;
}) {
  if (total === undefined || summary === undefined) {
    return (
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            className="rounded-2xl border border-border/60 bg-card px-4 py-3.5 shadow-sm sm:px-5 sm:py-4"
          >
            <div className="h-3.5 w-20 animate-pulse rounded bg-muted" />
            <div className="mt-2.5 h-7 w-24 animate-pulse rounded bg-muted/60 sm:h-8" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
      <StatCard label="Sesija" value={String(total)} />
      <div title="Naplaćeno za plaćene seanse (dio klijenta i dio firme). Otkazana seansa ulazi samo sa zadržanom naknadom.">
        <StatCard
          label="Promet"
          value={fmtStatMoney(summary.revenue)}
          suffix="KM"
          tone="primary"
        />
      </div>
      <div title="Održane seanse i nedolasci koji su plaćeni.">
        <StatCard
          label="Zarada terapeuta"
          value={fmtStatMoney(summary.therapistEarnings)}
          suffix="KM"
        />
      </div>
      <StatCard
        label="Čeka uplatu"
        value={String(summary.pendingTransferCount)}
        tone={summary.pendingTransferCount > 0 ? "amber" : "neutral"}
      />
    </div>
  );
}
